<template>
  <div>
    <div class="banner">
      <img src="../../assets/img/Teabanner.png" alt />
    </div>
    <div class="bg">
      <div class="main">
        <div class="title">
          <img src="../../assets/img/Resource.png" alt />
          <div>立体化教材作为整体的教学、学习解决方案，主要包括主教材、配套电子资料、音像制品、网络出版物等。辅助内容主要包含主体知识、习题试题库及答案、教案、课件及其他内容。主要目的是为教师提供教学参考资料，为学生提供学习指导资料。</div>
        </div>
        <div class="item">
          <!-- <el-row :gutter="12">
                        <el-col :span="4" v-for="(item, index) in matItem" :key="index" class="itemMar">
                            <div class="grid-content bg-purple">
                                <img src="../../assets/img/Resourceitem.png" alt="">
                            </div>
                            </el-col>
          </el-row>-->

          <div v-for="(item, index) in matItem" :key="index" class="itemMar">
            <img src="../../assets/img/Resourceitem.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="relevant">
      <div class="title">
        <img src="../../assets/img/relevantLogo.png" alt />
      </div>
      <div class="relevantMain">
        <div class="Main">
          <div class="reltitle">
            <div class="recommend">最热课程推荐</div>
            <div class="more">查看更多 / SEE MORE</div>
          </div>
          <div class="course">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) in relevant" :key="index">
                <div class="grid-content bg-purple courseItem">
                  <div class="itemImg">
                    <img src="../../assets/img/relevantItem.png" alt />
                  </div>
                  <div class="itemTit">新突破大学英语综合教材</div>
                  <div class="user">马丽 黄群 卢大磊</div>
                  <div
                    class="itemDet"
                  >本课程根据机械制造业岗位任务分析、知识与技能需要，以能力培养为重点，重构机械制造学科体系中的机械制图、极限配合与技术测量、材料及热处理内容，体现了职业教学的实践性、职业性、开放性 本课程根据机械制造业岗位任务分析、知识与技能需要，以能力培养为重点，重构机械制造学科体系中的机械制图、极限配合与技术测量、材料及热处理内容，体现了职业教学的实践性、职业性、开放性。</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="reltitle">
            <div class="recommend">最新素材推荐</div>
            <div class="more">查看更多 / SEE MORE</div>
          </div>
          <div class="course">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) in relevant" :key="index">
                <div class="grid-content bg-purple">
                  <div class="itemnewImg">
                    <img src="../../assets/img/relevantItem.png" alt />
                  </div>
                  <div class="itemTit">新突破大学英语综合教材</div>
                  <div class="user">文件大小：10kb</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      matItem: [
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 },
        { hah: 1 }
      ],
      relevant: [{ id: 1 }, { id: 1 }, { id: 1 }, { id: 1 }]
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 180px;
  img {
    width: 100%;
    height: 180px;
  }
}
.bg {
  width: 100%;
  height: 100%;
  // background-image: url('../../assets/img/ResourceBg.png');
}
.main {
  overflow: hidden;
  // height: 594px;
}
.title {
  margin-bottom: 28px;
  text-align: center;
  img {
    margin: 26px auto;
  }
  div {
    font-size: 14px;
    color: rgba(136, 136, 136, 1);
    line-height: 24px;
  }
}

.item {
  width: 100%;
  overflow: hidden;
  height: 100%;
  .itemMar {
    margin-bottom: 12px;
    width: 19%;
    height: 106px;
    float: left;
    margin-right: 11px;
    img {
      width: 100%;
    }
  }
}
.relevant {
  background-image: url('../../assets/img/relevant.png');
  min-height: 440px;
  background-repeat: no-repeat;
}
.relevantMain {
  width: 1112px;
  margin: 0 auto;
  // position: relative;
  height: 100%;
  background-color: #fff;
  .Main {
    margin: 0 30px;
    .reltitle {
      overflow: hidden;
      padding: 50px 0 20px;

      .recommend {
        float: left;
        font-size: 22px;
        color: rgba(51, 51, 51, 1);
      }
      .more {
        float: right;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
}
.courseItem {
  height: 335px;
  overflow: hidden;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e6e6e6;
  .itemImg {
    height: 150px;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .itemTit {
    font-size: 16px;
    color: rgba(181, 14, 5, 1);
    margin: 17px 0 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user {
    font-size: 12px;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 22px;
  }
  .itemDet {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    height: 97px;
  }
}
.itemnewImg {
  width: 100%;
  height: 110px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: rgba(181, 14, 5, 1);
  margin: 17px 0 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 50px;
}
</style>

